import DismissibleFormWrapper from '../DismissibleFormWrapper';
import FloorForm from './FloorForm';

const floorFormFactory =
    ({ headerButtonTextKey }: $TSFixMe) =>
    ({ onClose, onSubmit, scope, opened, initialValues = {} }: $TSFixMe) => (
        <DismissibleFormWrapper onClose={onClose} opened={opened} headerButtonTextKey={headerButtonTextKey}>
            <FloorForm initialValues={initialValues} form={scope} onSubmit={onSubmit} />
        </DismissibleFormWrapper>
    );

export default floorFormFactory;
